import {
  Box, Button, Divider, Typography, CircularProgress,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper,
  IconButton,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Grid,
} from '@mui/material'
import { EyeIcon, Plus, SearchIcon } from 'lucide-react'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { getAllShowroom } from '../../Apis/Showroom'
import { toast } from 'react-toastify'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm'
import { useDebounce } from "../../hooks/useDebounce";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import apiClient from '../../utils/apiClient';

const DisplayShowroom = () => {
  const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
    confirmDelete } = useContext(Context);
  const navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [error, setErrors] = useState(" ");
  const [showroom, setShowroom] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [status, setStatus] = useState("")

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedShowroom, setSelectedShowroom] = useState(null);
  const open = Boolean(anchorEl);
const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const handleAddClick = () => {
    navigate('/create-edit-showroom')
  }
  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value === 'true');
  // };
  const handleStatusChange = (e) => {
  const value = e.target.value;

  if (value === "") {
    setStatus("");
  } else {
    setStatus(value === "true");
  }
};
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  
//   const handleSearch = async () => {
//   try {
//     setLoading(true);

//     const payload = {
//       search: searchTerm,
//       page,
//       pageSize: limit,
//     };

//     if (status !== "") {
//       payload.isActive = status;
//     }

//     const data = await getAllShowroom(payload);

//     if (data?.status === true) {
//       setShowroom(data?.showrooms);
//       setTotalItems(data?.totalItems);
//       setTotalPages(data?.totalPages);
//     } else {
//       setErrors(data?.message);
//     }
//   } catch (error) {
//     setErrors(
//       error?.response?.data?.message || "Error fetching services"
//     );
//   } finally {
//     setLoading(false);
//   }
// };

const handleSearch = async (searchValue = debouncedSearchTerm) => {
  try {
    setLoading(true);

    const payload = {
      search: searchValue,
      page,
      pageSize: limit,
    };

    if (status !== "") {
      payload.isActive = status;
    }

    const data = await getAllShowroom(payload);

    if (data?.status === true) {
      setShowroom(data?.showrooms);
      setTotalItems(data?.totalItems);
      setTotalPages(data?.totalPages);
    } else {
      setErrors(data?.message);
    }
  } catch (error) {
    setErrors(
      error?.response?.data?.message || "Error fetching services"
    );
  } finally {
    setLoading(false);
  }
};

// useEffect(() => {
//   handleSearch();
// }, [status, page, limit]);
useEffect(() => {
  handleSearch();
}, [debouncedSearchTerm, status, page, limit]);

  const handleEditClick = (showroomId) => {
    navigate('/create-edit-showroom', { state: { showroomId } })
  }
  const handleViewClick = (showroomId) => {
    navigate('/view-showroom-details', { state: { showroomId } })
  }

  const handleDelete = async () => {
    setIsConfirmDeleteModelOpen(false)
    setLoading(true)
    try {
      const response = await apiClient.delete(`/showroom/deletedshowroom/${itemIdToDelete}`);
      if (response?.data?.status === true) {
        toast.success(response?.data?.message || "Showroom deleted successfully")
        handleSearch()
      }
    } catch (error) {

      setErrors(error?.response?.data?.message || "Error deleting showroom")
    }
    finally {
      setLoading(false)
    }

  };


  const handleMenuClick = (event, showroom) => {
    setAnchorEl(event.currentTarget);
    setSelectedShowroom(showroom);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedShowroom(null);
  };

  const handleBankDetails = (showroom) => {
    navigate("/create-edit-bank-details", {
      state: {
        entityId: showroom,
        entityType: "showroom"
      }
    });
  };


const handleDownload = async () => {

  try {

    const response = await apiClient({
      url: `/showroom/showrooms/download`,
      method: "GET",
      responseType: "blob",
    });

    const blob = new Blob(
      [response.data],
      {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `showrooms_${Date.now()}.xlsx`
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error("Download failed:", error);

  }
};


  return (
    <> <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
  
  <Typography variant="h3">Service Centers</Typography>

  {/* RIGHT SIDE BUTTON GROUP */}
  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>

    <Button
      variant="contained"
      sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
       onClick={handleDownload}
    >
      <FileDownloadIcon fontSize="small" />
      <Typography>Download</Typography>
    </Button>

    <Button
      variant="contained"
      sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
      onClick={handleAddClick}
    >
      <Plus size={23} />
      <Typography>Add Service Center</Typography>
    </Button>

  </Box>
</Box>
      <Divider sx={{ mb: 2 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: "wrap", mb: 2, gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search by name,email or phone"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}

            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon size={14} />
                </InputAdornment>
              ),
            }}
            sx={{ width: 600 }}
          />

          <FormControl fullWidth size='small'>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              id="status-select"
              // value={status}
               value={status === "" ? "" : status.toString()}
              label="Status"
              onChange={handleStatusChange}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">Inactive</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, alignItems: 'center' }}>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Rows per page</InputLabel>
            <Select value={limit} label="Rows per page" onChange={handleLimitChange}>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
          >
            <SearchIcon size={14} />
            <Typography>Search</Typography>
          </Button> */}
        </Box>
      </Box>


      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100px">
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} elevation={1}>
          <Table>
            <TableHead>
              <TableRow>
                {/* <TableCell><strong>Image</strong></TableCell> */}
                <TableCell><strong>Name</strong></TableCell>
                <TableCell><strong>Email</strong></TableCell>
                <TableCell><strong>Brand</strong></TableCell>
                <TableCell><strong>Phone</strong></TableCell>
                <TableCell><strong>Address</strong></TableCell>
                <TableCell><strong>Is Active</strong></TableCell>
                <TableCell align='right'><strong>Actions</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {showroom?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No showroom found.
                  </TableCell>
                </TableRow>
              ) : (
                showroom?.map((showroom) => (
                  <TableRow key={showroom.id}>
                    {/* <TableCell>
                        <img
                          src={banners.bannerUrl}
                          alt={banners?.name}
                          style={{ width: 70, height: 70, borderRadius: 5 }}
                        />
                      </TableCell> */}
                    <TableCell>{showroom?.name}</TableCell>
                    <TableCell>{showroom?.email}</TableCell>
                    <TableCell>{showroom?.brand}</TableCell>
                    <TableCell>{showroom?.contact}</TableCell>
                    <TableCell>{showroom?.address}</TableCell>

                    <TableCell>{showroom?.isActive === true ? "true" : "false"}</TableCell>
                    {/* <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                        <IconButton
                          onClick={() => handleEditClick(showroom.showRoomId)}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => handleViewClick(showroom.showRoomId)}
                        >
                          <EyeIcon />
                        </IconButton>
                        <IconButton color="error"
                          onClick={() => handleDelete(showroom.showRoomId)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </TableCell> */}

                    <TableCell align='right'>
                      <IconButton onClick={(e) => handleMenuClick(e, showroom)}>
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={() => {
              handleEditClick(selectedShowroom?.showRoomId);
              handleMenuClose();
            }}>Edit</MenuItem>

            <MenuItem onClick={() => {
              handleViewClick(selectedShowroom?.showRoomId);
              handleMenuClose();
            }}>View</MenuItem>

            <MenuItem onClick={() => {
              confirmDelete(selectedShowroom?.showRoomId);
              handleMenuClose();
            }}>Delete</MenuItem>

            <MenuItem onClick={() => {
              handleBankDetails(selectedShowroom?.showRoomId);
              handleMenuClose();
            }}>Bank Details</MenuItem>
          </Menu>
        </TableContainer>
      )}
      {error && <Typography color='error' variant='body2' sx={{ mt: 2 }}>{error}</Typography>}


    </Box>

      {/* Pagination */}
      {totalItems > 0 && (
        <Box mt={2} display="flex" justifyContent="center" alignItems="center">
          <Pagination
            count={totalPages > 0 ? totalPages : 1}
            page={page > totalPages ? totalPages : page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            showFirstButton
            showLastButton
            disabled={totalPages === 0}
            siblingCount={0}
            boundaryCount={1}
            sx={{
              '& .MuiPaginationItem-root': {
                height: 30,
                minWidth: 30,
                fontSize: '1rem',
                // marginTop: '10px'
                margin: "15px"
              }
            }}
          />
        </Box>
      )}

 <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
    </>
  )
}

export default DisplayShowroom
